module.exports = __webpack_public_path__ + "img/qr-code-left.a89bce76.png";